import { Experiment, YammerState } from '../../state/types';
import { getExperimentTreatment } from '../experiments/selectors';
import { getCurrentSessionUser } from '../session/selectors';

export const isVivaEngageCopilotMVPEnabled = (state: YammerState) => {
  const isFlighted = getExperimentTreatment(state, Experiment.VivaEngageCopilotMVP) === true;
  const isGuest = getCurrentSessionUser(state).isGuest;

  return isFlighted && !isGuest;
};
